import React, { type ReactNode } from 'react';

import { cssMap } from '@compiled/react';
import { token } from '@atlaskit/tokens';

import { Text, Inline, Stack } from '@atlaskit/primitives/compiled';
import Heading from '@atlaskit/heading';

import type { TypeDefinition } from '../../../common/application-types.tsx';

const styles = cssMap({
	productCard: {
		borderColor: token('color.border'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderRadius: token('border.radius'),
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

const ProductCard = (props: {
	applicationType: TypeDefinition;
	displayUrl: string;
	heading: string;
	statusLozenge?: ReactNode;
}) => {
	const { applicationType, displayUrl, heading } = props;

	return (
		<Stack xcss={styles.productCard} space="space.100">
			<Inline spread="space-between" alignBlock="center">
				<Heading size="xxsmall" as="h2">
					{heading}
				</Heading>
				{props.statusLozenge}
			</Inline>
			<Inline space="space.100" alignBlock="center">
				{applicationType.icon}
				<Stack>
					<Text>{displayUrl}</Text>
					<Text color="color.text.subtle" size="small">
						{applicationType.name}
					</Text>
				</Stack>
			</Inline>
		</Stack>
	);
};

export default ProductCard;
